<template>
    <section class="scrolling-banner">
      <div class="slider-track">
        <div class="slide" v-for="(img, index) in repeatedImages" :key="index">
          <img :src="img" alt="Banner image" />
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: "ScrollingBanner",
    data() {
      return {
        images: [
          require("@/assets/s1.png"),
          require("@/assets/s2.png"),
    
          require("@/assets/s5.png"),
          require("@/assets/s6.png"),
          require("@/assets/s14.png"),
          require("@/assets/s15.png"),
        ],
      };
    },
    computed: {
      repeatedImages() {
        return [...this.images, ...this.images]; // repeat for seamless scroll
      },
    },
  };
  </script>
  
  <style scoped>
  .scrolling-banner {
    width: 100%;
    height: 320px;
    overflow: hidden;
      background-color:rgb(2, 7, 22);
    position: relative;
  }
  
  .slider-track {
    display: flex;
    animation: scroll-left 30s linear infinite;
    /* Minimum width to accommodate all repeated images */
    width: max-content;
  }
  
  .slide {
    flex: 0 0 auto;
    width: 450px; /* fixed width for each image */
    height: 400px;
    overflow:hidden;
    border-radius: 50px; /* ili koliko želiš, npr. 8px za blago, 50% za krug */
    margin-right: 10px; /* smaller spacing */
  }
  .slide img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
 
}

  
  /* Responsive height */
  @media (max-width: 768px) {
    .scrolling-banner {
      height: 250px;
    }
    .slide {
      height: 250px;
      width: 350px;
    }
  }
  
  @keyframes scroll-left {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }
  </style>
  